import axios from 'axios';

/**
 * Pulls a human-readable message out of an API failure.
 * The heal endpoints answer either with `{ error: '...' }`, a bare string, or
 * an empty body, so anything unrecognised falls back to the caller's message.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
    if (!axios.isAxiosError(error)) {
        return fallback;
    }

    const data = error.response?.data;

    if (typeof data === 'string' && data.trim()) {
        return data.trim();
    }

    if (data && typeof data === 'object') {
        const message = (data as Record<string, unknown>).error ?? (data as Record<string, unknown>).detail;
        if (typeof message === 'string' && message.trim()) {
            return message.trim();
        }
    }

    return fallback;
};
